<template>
  <a-modal
    :visible="visible"
    width="484px"
    class="modal-queue"
    title="Colas vinculadas"
    :bodyStyle="{ padding: '20px 0 0 0' }"
    wrapClassName="modal-queue"
    centered
    @cancel="emit('update:visible', false)"
  >
    <CustomScrollbar class="scroll-area" auto>
      <ul class="modal-list">
        <li v-for="queue in queues" :key="queue.id">{{ queue.name }}</li>
      </ul>
    </CustomScrollbar>
    <template #footer>
      <div style="text-align: center" class="footer">
        <a-button key="back" @click="emit('update:visible', false)">Cerrar detalles</a-button>
      </div>
    </template>
  </a-modal>
</template>

<script setup lang="ts">
import { Queue } from "@/@types/global";
import CustomScrollbar from "@/app/shared/components/organisms/CustomScrollbar.vue";

const props = defineProps<{
  visible: boolean;
  queues: Queue[];
}>();

const emit = defineEmits<{
  "update:visible": [visible: boolean];
}>();

</script>

<style scoped lang="sass">
:global(.modal-queue .ant-modal-content)
  height: 404px
  display: flex
  flex-direction: column
  padding-bottom: 0 

:global(.modal-queue .ant-modal-body)
  flex: 1
  min-height: 0
  overflow: hidden

:global(.modal-queue .scroll-area)
  height: 100%

.modal-list li
  line-height: 22px
  padding-bottom: 12px
  color: #262626E0

.footer
  display: flex
  align-items: center
  justify-content: center
  padding: 12px 0
  width: 100%
</style>

